module.exports = __webpack_public_path__ + "img/primevue-logo.d32bce0e.svg";